export const searchBoxBehaviors = {
  openSuggestions: {methodName: 'openSuggestions'},
  closeSuggestions: {methodName: 'closeSuggestions'},
  getSelectionStart: {methodName: 'getSelectionStart'},
  getSelectionEnd: {methodName: 'getSelectionEnd'},
};
